import * as React from "react";
import { styled } from "@mui/system";
import MUIDivider from "@mui/material/Divider";
import { DividerProps as DividerPropsMUI } from "@mui/material/Divider";

declare module "@mui/material/Divider" {
  interface DividerPropsVariantOverrides {
    alert: true;
  }
}
export interface DividerProps extends DividerPropsMUI {
  component?: React.ElementType;
}

export const Divider: (props: DividerProps) => JSX.Element = styled(
  React.forwardRef<HTMLHRElement, DividerProps>((props, ref) => (
    <MUIDivider ref={ref} {...props} />
  )),
  {
    name: "Divider",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiDivider-root.MuiDivider-fullWidth.MuiDivider-light": {
    background: theme.palette.primary.borderDefault,
    border: "none",
    height: 1
  },
  "&.MuiDivider-root.MuiDivider-fullWidth": {
    backgroundColor: theme.palette.primary.primary,
    border: "none",
    height: 2
  },
  "&.MuiDivider-root.MuiDivider-inset": {
    background: theme.palette.primary.borderDefault,
    border: "none",
    height: 1
  },
  "&.MuiDivider-root.MuiDivider-fullWidth.MuiDivider-vertical.MuiDivider-flexItem":
    {
      background: theme.palette.primary.borderDefault,
      height: "auto",
      width: 1
    },
  "&.MuiDivider-root.MuiDivider-middle.MuiDivider-vertical.MuiDivider-flexItem":
    {
      background: theme.palette.primary.borderDefault
    }
}));
